import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import Divider from '../../atoms/Divider';
import Text from '../../atoms/Text';
import LabelTextGroupList from '../LabelTextGroupList';

import styles from './DetailsBasicInfoSection.module.scss';
import usePresenter from './DetailsBasicInfoSection.presenter';
import getProps from './DetailsBasicInfoSection.props';
import { DetailsBasicInfoSectionCombinedProps } from './types';


const DetailsBasicInfoSection: React.FC<DetailsBasicInfoSectionCombinedProps> = (props) => {
  const {
    className,
    classes,
    text,
    button,
    divider,
    labelTextGroupList,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.detailsBasicInfoSection;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.header, classes?.header)}>
        <div className={cx(styles.topContent, classes?.topContent)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
          <Button
            className={cx(styles.button, classes?.button)}
            {...internalProps.button}
            {...button}/>
        </div>
        <Divider
          className={cx(styles.divider, classes?.divider)}
          {...internalProps.divider}
          {...divider}/>
      </div>
      <LabelTextGroupList
        className={cx(styles.labelTextGroupList, classes?.labelTextGroupList)}
        {...internalProps.labelTextGroupList}
        {...labelTextGroupList}/>
    </div>
  );
};

export default DetailsBasicInfoSection;

